export default __webpack_public_path__ + "static/media/JAKLogo.16016f45.svg";